
define('template!ordersListInfosView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(client != '') { ;
__p += '\n    <div class="client">' +
((__t = ( client )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n';
 if(order != '') { ;
__p += '\n    <div class="order">' +
((__t = ( order )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n';
 if(price != '') { ;
__p += '\n    <div class="price">' +
((__t = ( price )) == null ? '' : __t) +
'</div>\n';
 } ;


}
return __p
};});

